import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAssociated } from "app/models/core/lab/associated";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-sharedAssociated',
  templateUrl: './sharedAssociated.component.html'
})

export class SharedAssociatedComponent implements OnInit {

  list: IAssociated[] = [];

  displayedColumns: string[] = ['labName', 'director', 'taxId', 'comments'];

  sharedList: IAssociated[] = [];
  selectedShared: IAssociated;
  dataSource = new MatTableDataSource<IAssociated>(this.list);

  listFilter = '';

  editMode = 'list';
  inputComments = '';
  inputLab: IAssociated;
  search = '';
  selected = '';
  inputLabName = '';
  inputDirector = '';
  inputTaxId = '';
  label = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.setupTable();
    }
  }

  refreshAssociated() {
    this.labService.getAssociatedLab(this.labService.lab.stateNumber).subscribe(
      assoc => {
        this.labService.associated = assoc;
        this.setupTable();
        this.editMode = 'list';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  setupTable() {
    this.list = this.labService.associated.sharedList;
    this.dataSource.data = this.list;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  add() {
    this.editMode = 'add';
    this.label = 'Enter state number or lab name.';  }

  save() {
    if (this.inputLab != null) {
      if (this.editMode == 'add') {
        this.inputLab.newAssociatedLabId = this.inputLab.labId;
      }
      this.inputLab.labId = this.labService.lab.labId;
      this.inputLab.comments = this.inputComments;
      this.labService.saveAssociatedLab(this.inputLab, 'Shared').subscribe(
        () => {
          this.refreshAssociated();
        },
        error => console.log('error: ', error),
        () => {
        }
      );
    }
  }

  cancel() {
    this.editMode = 'list';
    this.sharedList = [];
  }

  delete(): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }

    this.labService.deleteAssociated(this.inputLab.sharedId, 'Shared').subscribe(
      () => {
        this.refreshAssociated();
        this.clearSearch();
      },
      error => console.log('error: ', error),
      () => {
      }
    );

  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  rowclick(row: IAssociated) {
    this.editMode = 'edit';
    this.inputLab = row;
    this.inputComments = row.comments;
    this.inputLabName = row.labName;
    this.inputDirector = row.director;
    this.inputTaxId = row.taxId
  }

  updateFields(value: IAssociated) {
    this.inputLab = value;
    this.inputDirector = value.director;
    this.inputTaxId = value.taxId
  }


  getSharedList() {
    if (this.search != null && this.search != '') {
      this.labService.getSharedAssociatedList(this.search).subscribe(
        res => {
          this.sharedList = res;
          this.editMode = 'add';
          if (this.sharedList.length == 0){
            this.label = 'No labs found.';
          }
          else {
            this.label = 'Enter state number or lab name.';
          }
        },
        error => console.log('error', error),
        () => {
        }
      );
    }
  }

  clearSearch() {
    this.search = "";
    this.sharedList = [];
    this.label = 'Enter state number or lab name.';
    }

}